export const HTTP_EDITOR_ROOT_ATTR = 'data-http-editor';

export const HTTP_EDITOR_FIND_EVENT = 'http-editor-find';

const HTTP_EDITOR_ROOT_SELECTOR = `[${HTTP_EDITOR_ROOT_ATTR}]`;

let lastFocusedHttpEditor: Element | null = null;

const isDocumentFallbackFocus = (activeElement: Element | null): boolean => {
  if (!activeElement) {
    return true;
  }

  const rootNode = activeElement.getRootNode();

  if (!(rootNode instanceof Document)) {
    return false;
  }

  return (
    activeElement === rootNode.body ||
    activeElement === rootNode.documentElement
  );
};

export const bindHttpEditorFindRoot = ({
  editorRoot,
  onFind,
}: {
  editorRoot: HTMLElement;
  onFind: EventListener;
}): (() => void) => {
  editorRoot.setAttribute(HTTP_EDITOR_ROOT_ATTR, '');

  const rememberFocus = () => {
    lastFocusedHttpEditor = editorRoot;
  };

  editorRoot.addEventListener('focusin', rememberFocus);
  editorRoot.addEventListener(HTTP_EDITOR_FIND_EVENT, onFind);

  return () => {
    editorRoot.removeEventListener('focusin', rememberFocus);
    editorRoot.removeEventListener(HTTP_EDITOR_FIND_EVENT, onFind);
    editorRoot.removeAttribute(HTTP_EDITOR_ROOT_ATTR);

    if (lastFocusedHttpEditor === editorRoot && !editorRoot.isConnected) {
      lastFocusedHttpEditor = null;
    }
  };
};

export function dispatchHttpEditorFindIfFocused(
  activeElement: Element | null,
): boolean {
  const fromActive = activeElement?.closest(HTTP_EDITOR_ROOT_SELECTOR);
  const fromFocusWithin = activeElement?.ownerDocument.querySelector(
    `${HTTP_EDITOR_ROOT_SELECTOR}:focus-within`,
  );
  const editorRoot =
    fromActive ??
    fromFocusWithin ??
    (isDocumentFallbackFocus(activeElement) &&
    lastFocusedHttpEditor?.isConnected
      ? lastFocusedHttpEditor
      : null);

  if (!editorRoot) {
    return false;
  }

  editorRoot.dispatchEvent(new Event(HTTP_EDITOR_FIND_EVENT));

  return true;
}
